import "./SignInControl.scss"

import React, { useState } from "react"
import { SocialSignInButton, Form, Message } from "@fider/components"
import { Divider } from "@fider/components/layout"
import { Failure, isCookieEnabled } from "@fider/services"
import { useFider } from "@fider/hooks"
import { Trans } from "@lingui/macro"

interface SignInControlProps {
  useEmail: boolean
  redirectTo?: string
  onEmailSent?: (email: string) => void
}

export const SignInControl: React.FunctionComponent<SignInControlProps> = (props) => {
  const fider = useFider()
  const [showEmailForm, setShowEmailForm] = useState(fider.session.tenant ? fider.session.tenant.isEmailAuthAllowed : true)
  const [error] = useState<Failure | undefined>(undefined)
  const [iframeHeight, setIframeHeight] = useState<string>("600")

  const forceShowEmailForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    setShowEmailForm(true)
  }

  console.log("hello");
  
  window.addEventListener("message", (event) => {
  console.log("hell1");
  
    if (event.origin === "https://ideas.ria.com" || event.origin === "http://ideas.ria.local" || event.origin === "https://login.ria.com") {
      if (event.data) {
        try {
          const data = JSON.parse(event.data);

          if (data.height) {
            setIframeHeight(String(data.height))
          }

        } catch (error) {

        }
      }
    }
  }, false);

  const providersLen = fider.settings.oauth.length

  if (!isCookieEnabled()) {
    return (
      <Message type="error">
        <h3 className="text-display">Cookies Required</h3>
        <p>Cookies are not enabled on your browser. Please enable cookies in your browser preferences to continue.</p>
      </Message>
    )
  }

  return (
    <div className="c-signin-control">
      {providersLen > 0 && (
        <>
          <div className="c-signin-control__oauth mb-2">
            {fider.settings.oauth.map((o) => (
              <React.Fragment key={o.provider}>
                <SocialSignInButton option={o} redirectTo={props.redirectTo} />
              </React.Fragment>
            ))}
          </div>
          {props.useEmail && <Divider />}
        </>
      )}

      {props.useEmail &&
        (showEmailForm ? (
          <div>
            <Form error={error}>
              <iframe style={{width: '100%', height: `${iframeHeight}px`}} frameBorder="0" id="login_iframe" src="/iframe-ria-login/login/21/1"></iframe>
            </Form>
            {!fider.session.tenant.isEmailAuthAllowed && (
              <p className="text-red-700 mt-1">
                <Trans id="signin.message.onlyadmins">Currently only allowed to sign in to an administrator account</Trans>
              </p>
            )}
          </div>
        ) : (
          <div>
            <p className="text-muted">
              <Trans id="signin.message.emaildisabled">
                Email authentication has been disabled by an administrator. If you have an administrator account and need to bypass this restriction, please{" "}
                <a href="#" className="text-bold" onClick={forceShowEmailForm}>
                  click here
                </a>
                .
              </Trans>
            </p>
          </div>
        ))}
    </div>
  )
}
